export default __webpack_public_path__ + "static/media/eight_of_swords.f9528b05.png";